<template>
  <!--
      作者 kmdshop
      时间：2020-06-09
      描述：会员-余额管理
  -->
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
      <!-- <el-tab-pane :label="getAppinfo('balance_text')+'设置'" name="first"></el-tab-pane> -->
      <el-tab-pane :label="getAppinfo('balance_text')+'明细'" name="first"></el-tab-pane>
    </el-tabs>

    <!--余额设置-->
    <!-- <Setting v-if="activeName == 'first'"></Setting> -->
    <!--余额明细-->
    <Log v-if="activeName == 'first'"></Log>
    
  </div>
</template>
<script>
import Setting from './part/Setting';
import Log from './part/Log';
export default {
  components: {
    Setting,
    Log
  },
  data() {
    return {
      form: {
        status: 0
      },
      activeName: 'first'
    };
  },
  methods: {}
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/user/balance/index.vue